const styleSheet = () => ({
  searchBarContainer: {
    position: 'relative',
    width: '300px',
    display: 'inline-block',
    verticalAlign: 'text-bottom',
  },
  errorText: {
    position: 'absolute',
    left: '10%',
    height: '15px',
    width: '218px',
    color: '#FF6969',
    fontFamily: "'Museo Sans', sans-serif",
    fontWeight: 300,
    fontSize: '12px',
    lineHeight: '15px',
  },
});

export default styleSheet;
